/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useMemo } from "react";
import Tooltip from "../Tooltip/Tooltip";
import { PatientSyncStatusMsgs } from "../../constants/PatientSyncStatus";
import { formatDate } from "../../utils/helpers";

const SyncStatusIcon = ({ status, date }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const statusProps = useMemo(
    () => PatientSyncStatusMsgs.find((i) => status == i.key) || PatientSyncStatusMsgs[0],
    [status]
  );

  const tooltipText = useMemo(
    () => statusProps.text.replace("{}", formatDate(new Date(date), "DATE_AND_TIME_DEFAULT")),

    [statusProps, date]
  );

  return (
    <div className="container-with-tooltip">
      <Tooltip testId="rls-status-msg" text={tooltipText} isVisible={showTooltip} />
      <statusProps.Icon
        id="rls-icon"
        data-testid="rls-icon"
        className="rls-icon"
        onMouseOver={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      />
    </div>
  );
};
export default SyncStatusIcon;
